import { useEffect, useState } from "react";
import moment from "moment";
import { MdChevronRight } from "react-icons/md";
import { Link } from "react-router-dom";
import api from "@/components/customAxios/Axios";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "../toast";
import CancelSubscription from "./CancelSubscription";
import ViewPaymentHistory from "./ViewPaymentHistory";
const Subscription = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const [companyData, setCompanyData] = useState({
		paymentDate: "",
		nextPaymentDate: "",
		amount: "",
		planName: "",

	});
	const [paymentsHistory, setPaymentHistory] = useState([]);
	const [showPaymentHistory, setShowPaymentHistory] = useState(false);
	const [callFuntionFlag, setCallfuntionFlag] = useState(false);
	const [subscriptionCancelledAt, setSubscriptionCancelledAt] = useState("");
	const [isSubCancel, setIsSubCancel] = useState(null);
	const [isSubActive, setIsSubActive] = useState(null);
	const [trailData, setTrailData] = useState("");
	const userIsTrail = localStorage.getItem("role") === "guest";
	const plans: Record<string, string> = {
		Silver: "Basic Plan",
		Golden: "Pro Plan",
		Platinum: "Premium Plan",
	};

	const getSubscriptionDetails = async () => {
		try {
			setLoading(true);

			const url = `/get_payment_details?user_id=${localStorage.getItem(
				"user"
			)}`;
			const response = await api.get(url);

			if (response.status === 200) {
				if (userIsTrail) {
					setTrailData(response.data.start_date || "");
				} else {
					setIsSubCancel(response.data.payments[0].is_subscription_cancelled);
					setIsSubActive(response.data.payments[0].is_subscription_active)
					setPaymentHistory(response.data.payments);
					setCompanyData({
						paymentDate: moment(response.data.payments[0].payment_date).format(
							"DD MMMM YYYY"
						),
						nextPaymentDate: moment(response.data.payments[0].subscription_end_date)

							.format("DD MMMM YYYY"),
						amount: response.data.payments[0].amount,
						planName: plans[response.data.payments[0].subscription_plan_name],

					});
					if (response.data.payments[0].is_subscription_cancelled) {
						setSubscriptionCancelledAt(
							response.data.payments[0].subscription_cancelled_at
						);
					}
				}
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error Occurred",
				description: error.response?.data?.error || error.response?.data?.message || "An unknown error occurred",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		localStorage.removeItem("currentTab");
		getSubscriptionDetails();
	}, [callFuntionFlag]);
	return (
		<div className="">
			<button
				onClick={() => setShowPaymentHistory(false)}
				className=" block text-lg font-medium text-gray-400 mb-4"
			>
				<span className=" ">Membership Details</span>
				{showPaymentHistory && (
					<span className="text-black font-semibold"> / Payment History</span>
				)}
			</button>
			{!showPaymentHistory ? (
				<div className="border border-gray-500 rounded-md py-3 mt-4  ">
					<div className=" items-center">
						{/* membership data */}
						<div className=" ">
							<div className="flex justify-between gap- items-center w-full">
								<div className="bg-[#C3EEBC] text-[#2F6C57] font-semibold  rounded-r-2xl p-2">
									Member since{" "}
									{userIsTrail
										? trailData.length > 17
											? trailData?.slice(5, 16)
											: trailData
										: companyData.paymentDate || ""}
								</div>
								<div className="">

									{isSubCancel !== null && (
										<span
											className={`text-center p-2.5 px-3   rounded-l-2xl  text-sm  ${isSubCancel === true

												? "bg-[#F7C5C5] text-[#CA4F4F]" :
												isSubActive === true ?
													"bg-[#BDE4C3] text-[#438437]" : "bg-[#ffc55218] text-[#FFC452]"
												}`}
										>
											{isSubCancel === true ? "Cancelled" : isSubActive === true ? "Active" : "Expired"}
										</span>
									)}
								</div>
							</div>

							<div className="mx-4 my-3 space-y-1 text-sm ">
								<div className="flex items-center gap-3 my-3">
									<div className=" font-semibold text-lg">
										{userIsTrail ? "Free Trial" : companyData.planName || ""}{" "}
									</div>
								</div>
								{isSubCancel ? (
									<div className="text-gray-500 ">
										End Date:
										{" " + subscriptionCancelledAt?.slice(5, 16)}
									</div>
								) : (
									<div className="text-gray-500 ">
										{userIsTrail
											? "End Date: " +
											moment(trailData?.slice(0, 16))
												.add(7, "days")
												.format("DD MMMM YYYY")
											: "Next Payment: " + companyData.nextPaymentDate}
									</div>
								)}
							</div>
						</div>
						{/* data cards */}
						{/* <div className="">
						<QuickData date={dates} />
					</div> */}
					</div>
					<div className="divide-y mt-3">
						<Link
							to="/select-plan"
							className="flex justify-between items-center border-t  py-3  mx-4  "
						>
							<div>{userIsTrail ? "Upgrade to Pro" : "Manage Membership"}</div>
							<div className="flex items-center gap-2  cursor-pointer">
								<MdChevronRight />
							</div>
						</Link>
						{!userIsTrail && (
							<>
								<div
									className="flex justify-between items-center   py-3  mx-4 cursor-pointer "
									onClick={() => setShowPaymentHistory(true)}
								>
									<div>View Payment History</div>
									<div className="flex items-center gap-2  ">
										<MdChevronRight />
									</div>
								</div>

								<CancelSubscription setCallfuntionFlag={setCallfuntionFlag} />
							</>
						)}
					</div>
				</div>
			) : (
				<ViewPaymentHistory paymentHistory={paymentsHistory} />
			)}
		</div>
	);
};

export default Subscription;
